import React, { FC, JSXElementConstructor } from 'react';

import classNames from 'classnames';

import './BadgesContainer.scss';
import { BadgeProps } from './Badge';

type BadgeItemOptions = BadgeProps & {
    readonly badgeComponent: JSXElementConstructor<BadgeProps>;
};

export type BadgesContainerProps = {
    readonly layout: 'tile' | 'list';
    readonly badges: ReadonlyArray<BadgeItemOptions>;
    readonly showAll?: boolean;
    readonly className?: string;
};

export const BadgesContainer: FC<BadgesContainerProps> = ({ badges, showAll, className, layout }) => {
    return (
        <div
            data-testid="badges-container"
            className={classNames(
                'badges-container',
                `badges-container--${layout}`,
                showAll && 'badges-container--show-all',
                className
            )}
            data-displayname="BadgesContainer"
        >
            {badges.map(({ title, link, badgeKey, className, badgeComponent: Component }, index) => (
                <div key={`badge-item-${index}`} className={classNames('badge-item')}>
                    <Component className={className} title={title} link={link} badgeKey={badgeKey} />
                </div>
            ))}
        </div>
    );
};
